import { __assign, __extends } from "tslib";
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
/**
 * A component to show a list of actions inside a Card.
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacButton, PnmacCard } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <PnmacCard>
 *     <PnmacCard.Actions>
 *       <PnmacButton>Cancel</PnmacButton>
 *       <PnmacButton>Ok</PnmacButton>
 *     </PnmacCard.Actions>
 *   </PnmacCard>
 * );
 *
 * export default MyComponent;
 * ```
 */
var PnmacCardActions = /** @class */function (_super) {
  __extends(PnmacCardActions, _super);
  function PnmacCardActions() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacCardActions.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, __assign({}, this.props, {
      style: [styles.container, this.props.style]
    }), React.Children.map(this.props.children, function (child) {
      return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
        compacted: (child.props.compacted !== false).toString()
      }) : child;
    }));
  };
  PnmacCardActions.displayName = 'Card.Actions';
  return PnmacCardActions;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 8
  }
});
export default PnmacCardActions;